// Public runtime configuration, injected at build time by scripts/deploy-web.sh
// from Terraform outputs. None of these are secrets (research.md D-09).

interface AppConfig {
  apiBaseUrl: string;
  cognitoDomain: string;
  cognitoClientId: string;
  redirectUri: string;
}

function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(
      `Missing build-time configuration: ${name}. Run scripts/deploy-web.sh, which reads it from Terraform outputs.`,
    );
  }
  return value;
}

export const config: AppConfig = {
  apiBaseUrl: required('VITE_API_BASE_URL', import.meta.env['VITE_API_BASE_URL']),
  cognitoDomain: required('VITE_COGNITO_DOMAIN', import.meta.env['VITE_COGNITO_DOMAIN']),
  cognitoClientId: required('VITE_COGNITO_CLIENT_ID', import.meta.env['VITE_COGNITO_CLIENT_ID']),
  redirectUri: import.meta.env['VITE_REDIRECT_URI'] ?? `${window.location.origin}/auth/callback`,
};
